import { render } from "./CheckBoxSelectPair.vue?vue&type=template&id=6b604beb&scoped=true"
import script from "./CheckBoxSelectPair.vue?vue&type=script&lang=js"
export * from "./CheckBoxSelectPair.vue?vue&type=script&lang=js"

import "./CheckBoxSelectPair.vue?vue&type=style&index=0&id=6b604beb&lang=less&scoped=true"

import exportComponent from "/builds/cloudstack/keycloak-auth/.cloudstack-src/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b604beb"]])

export default __exports__